import {ReferralAttachmentModel} from './referral-attachment.model';
import {XauditModel} from '../../../../models/xaudit.model';
import {ContactDataModel} from '../../../../models/person/contact-data.model';
import {DoctorLicenseDataModel} from '../../../../models/doctors/doctor-license-data.model';
import {DoctorLocationDataModel} from '../../../../models/doctors/doctor-location-data.model';
import {DoctorSpecialtyDataModel} from '../../../../models/doctors/doctor-specialty-data.model';
import {DoctorArLocationDataModel} from '../../../../models/doctors/doctor-ar-location-data.model';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';

export class ReferralDataModel extends XauditModel {
    ReferralID = '';
    RefDoctorID = '';
    Patient_FirstName = '';
    Patient_MidName = '';
    Patient_LastName = '';
    Patient_DOB: Date = new Date();
    Patient_email = '';
    Patient_phone = '';
    Insurance_FirstName = '';
    Insurance_LastName = '';
    Insurance_DOB: Date = new Date();
    Insurance_Company: string = '';
    Insurance_Number: string = '';
    DiscomfortLevel: number;
    PatientInsuranceID: string;
    ToothIDsJSON = '';
    TeethDescription:string;
    ReferralScheduleItemID = '';
    enumReferralScheduleTypeID = '';
    ReferralTretmentIDsJSON = '';
    TreatmentDescription:string;
    ReferralOtherIDsJSON = '';
    Notes = '';
    enumReferralStatusID: string;
    ProviderID: string;
    AppointmentID: string;
    ReferralTime: Date = new Date();
    AppointmentLOCID:  number;
    AppointmentStartDate: Date = new Date();
    AppointmentEndDate: Date = new Date();
    DoctorID: string;
    Referral_FullName: string;
    Referral_email: string;
    Referral_phone: string;
    ReferringTDO_FullName: string;
    ReferringTDOPatient_FullName: string;
    PatientId: string;
    ReferringTDO_Specialty: DoctorSpecialtyDataModel;
    dataReferralAttachments: ReferralAttachmentModel[];
    StatusName:string;
    DataReferralDoctor: DataReferralDoctorsModel;
    Appointment: any;
    DiscomfortLevelDescription: string; 
    ReferralEntityDocID: string;
}

export class ReferralScheduleDataModel extends XauditModel {
    ReferralScheduleItemID: string;
    DoctorId: string;
    iOrder: number;
    ItemName: string;
    ItemDescription: string;
    ItemParameter: string;
    enumReferralScheduleTypeID: string;
    isEdit: boolean;
}

export class ReferralTreatmentsDataModel extends XauditModel {
    ReferralTretmentID: string;
    DoctorId: string;
    ItemName: string;
    ItemDescription: string;
    ItemParameter: string;
    iOrder: number;
}

export class ReferralOtherServicesDataModel extends XauditModel {
    ReferralOtherID: string;
    DoctorId: string;
    ItemName: string;
    ItemDescription: string;
    ItemParameter: string;
    iOrder: number;
}

export class ReferralProviderDataModel {
    providerID = '';
    providerName = '';
}

export class ReferringDoctorFilter {
    fullname: string;
    phone: string;
    email: string;

}


export class DataReferralDoctorsModel extends XauditModel {
    RefDoctorID: string;
    Provider_DoctorID: string;
    FullName: string;
    email: string;
    phone: string;
    DoctorId: string;
}

export class TDOReferringDataDoctorModel extends XauditModel{
    ContactId: string;
    DEA: string;
    NPI: string;
    DoctorId: string;
    LOCID: number;
    NoteGroupId: string;
    ReportName: string;
    TaxID: string;
    Title: string;
    UserId: string;
    providerName: string;
    dataContact: ContactDataModel;
    dataDoctorContacts: ContactDataModel[];
    // TODO: spelling
    dataDoctorLicences: DoctorLicenseDataModel[];
    dataDoctorLocations: DoctorLocationDataModel[];
    // TODO: spelling
    dataDoctorSpecialties: DoctorSpecialtyDataModel[];
    dataDoctorARLocations: DoctorArLocationDataModel[];
    enumDoctorClassificationID: string;
    enumDoctorTypeID: string;
    enumValidValueItem: EnumValidValueItemModel;
    PortraitDocumentID: string;
    SignatureDocumentID: string;
    isActiveDoctor: boolean;
    cfgReferralOtherService: ReferralOtherServicesDataModel[];
    cfgReferralTretment: ReferralTreatmentsDataModel[];
    cfgReferralSchedule: ReferralScheduleDataModel[];
    primaryEmail: string;
    primaryPhone: string;
    FullName: string;
    ReferralEntityDocID: string;
}


export class emailReferralPortalInformationModel {
    toReferringDocEmailAddress: string;
    toReferralDocEmailAddress: string;
    referringDoctor: string;
    referralDoctorContactName: string;
    patientFullName: string;
    teethInformation: string;
    isImageUploaded: boolean;
}

export interface IReferralAppointment {
    ReferralId: string;
    ReferralDoctorFullName:  string;
    ReferralDoctorID:  string;
    PatientFullName:  string;
    PatientID:  string;
    ProviderFullName:  string;
    ProviderId:  string;
    Teeth: string;
    AppNotes: string;
    Notes:  string;
    ReferralNotes: string;
}

export interface IRescheduleAppointment {
  AppointmentId: string;
  Patient_FullName: string;
  Reschedule_Note: string;
}

